import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import { Navbar, Container, Nav,  } from 'react-bootstrap'

import logo from "../images/idss-logo.svg"

const Header = ({ siteTitle }) => (
  <header>
    
    <Navbar variant="light" expand="lg">
      <Container className="maxWidth">
        <Link to="/"><img src={logo} width="275" alt={siteTitle} className="img-fluid" /></Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="navbar-nav ms-auto text-center pt-4 pt-md-0">
            <Link to="/about/" className="nav-item nav-link" activeClassName="active">About</Link>
            <Link to="/services/" className="nav-item nav-link" activeClassName="active">Services</Link>
            <Link to="/testimonials/" className="nav-item nav-link" activeClassName="active">Testimonials</Link>
            <Link to="/resources-events/" className="nav-item nav-link" activeClassName="active">Resources & Events</Link>
            <Link to="/contact/" className="nav-item nav-link" activeClassName="active">Contact</Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
